
var stache = require('can/view/stache/stache');
module.exports = stache("<iframe id=\"holesIframe\" src=\"//{{iframeEnvironment}}/ballplots/index.html?h={{id}}\" frameborder=\"0\" scrolling=\"no\" {{#if className}}class=\"{{className}}\"{{/if}}></iframe>");